export type CallHangupParty = "us" | "them" | "unknown" | null | undefined;

/**
 * Who ended the call, as a sentence. "them" is the clinic's phone system: the
 * platform dials into their IVR, so a hangup from that side is the clinic line.
 */
export function formatCallEndedBy(party: CallHangupParty): string | null {
  if (party === "us") return "We ended the call";
  if (party === "them") return "The clinic line ended the call";
  if (party === "unknown") return "Call ended unexpectedly";
  return null;
}

/** Just the party, for a labelled summary field or a spreadsheet cell. */
export function formatCallEndedByParty(party: CallHangupParty): string | null {
  if (party === "us") return "Us";
  if (party === "them") return "The clinic line";
  if (party === "unknown") return "Unknown";
  return null;
}
